import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonBadge from "components/ArgonBadge";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getFaQById } from "services/faqService";
import { CircularProgress } from "@mui/material";

function ViewFAQ() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [faq, setFaq] = useState(null);

  useEffect(() => {
    const fetchFaqDetails = async () => {
      setLoading(true);
      try {
        const response = await getFaQById(id);
        if (response.success) {
          setFaq(response.data);
        }
      } catch (error) {
        console.error("Error fetching FAQ:", error);
        toast.error(error.message || "Failed to fetch FAQ details");
        navigate("/faq");
      } finally {
        setLoading(false);
      }
    };

    fetchFaqDetails();
  }, [id, navigate]);

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <ArgonBox
          py={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="50vh"
        >
          <CircularProgress />
        </ArgonBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card>
            <ArgonBox p={3}>
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <ArgonTypography variant="h5" fontWeight="medium">
                  FAQ Details
                </ArgonTypography>
                <ArgonButton variant="outlined" color="secondary" onClick={() => navigate("/faq")}>
                  Back to List
                </ArgonButton>
              </ArgonBox>

              {faq && (
                <ArgonBox>
                  <Grid container spacing={3}>
                    {/* FAQ Type */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="button" fontWeight="bold" color="text">
                        FAQ Type
                      </ArgonTypography>
                      <ArgonBox mt={1}>
                        <ArgonBadge
                          variant="gradient"
                          badgeContent={faq.FaQType}
                          color={faq.FaQType === "PARENT" ? "info" : "success"}
                          size="md"
                          container
                        />
                      </ArgonBox>
                    </Grid>

                    {/* Question */}
                    <Grid item xs={12}>
                      <ArgonTypography variant="button" fontWeight="bold" color="text" mb={1}>
                        Question
                      </ArgonTypography>
                      <ArgonBox
                        mt={1}
                        p={2.5}
                        sx={{
                          backgroundColor: "rgba(0, 117, 255, 0.05)",
                          borderRadius: "8px",
                          border: "1px solid rgba(0, 117, 255, 0.2)",
                        }}
                      >
                        <ArgonTypography variant="body2" color="text">
                          {faq.question}
                        </ArgonTypography>
                      </ArgonBox>
                    </Grid>

                    {/* Answer */}
                    <Grid item xs={12}>
                      <ArgonTypography variant="button" fontWeight="bold" color="text" mb={1}>
                        Answer
                      </ArgonTypography>
                      <ArgonBox
                        mt={1}
                        p={2.5}
                        sx={{
                          backgroundColor: "rgba(76, 175, 80, 0.05)",
                          borderRadius: "8px",
                          border: "1px solid rgba(76, 175, 80, 0.2)",
                        }}
                      >
                        <ArgonTypography variant="body2" color="text">
                          {faq.answer}
                        </ArgonTypography>
                      </ArgonBox>
                    </Grid>

                    {/* Timestamps */}
                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="button" fontWeight="bold" color="text">
                        Created At
                      </ArgonTypography>
                      <ArgonTypography variant="body2" color="secondary" mt={0.5}>
                        {new Date(faq.createdAt).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </ArgonTypography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <ArgonTypography variant="button" fontWeight="bold" color="text">
                        Updated At
                      </ArgonTypography>
                      <ArgonTypography variant="body2" color="secondary" mt={0.5}>
                        {new Date(faq.updatedAt).toLocaleString("en-IN", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </ArgonTypography>
                    </Grid>
                  </Grid>
                </ArgonBox>
              )}
            </ArgonBox>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ViewFAQ;
